import React from 'react'
import { observer } from 'mobx-react-lite'
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import Clippy from 'features/vgc/reusable/Clippy'
import useKeyInputListener from 'reusable/hooks/useKeyInputListener'
import useStore from 'reusable/mobx-store-utils'
import FlexAlignRight from 'reusable/mui/utilities/FlexAlignRight'
import { useThemeStore } from 'theme/ThemeStore'
import GooseBotStore from './GooseBotStore'
import { useWebSocketStore } from 'websockets/WebSocketStore'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import Shrek from '/images/shrek-back.webp'
import useMatrix from './Matrix'

export default observer(function GooseBot() {
   const themeStore = useThemeStore()
   const webSocketStore = useWebSocketStore()
   const orgGuardStore = useOrgGuardStore()
   const matrix = useMatrix()
   const theGooseStore = useStore(sp => new GooseBotStore(sp), { themeStore, webSocketStore, orgGuardStore, matrix })

   useKeyInputListener(theGooseStore.modalState.open, 'gimmethegoose')
   useKeyInputListener(() => themeStore.setBackgroundImage(`url(${Shrek})`), 'gimmetheshrek')

   return <Clippy modalState={theGooseStore.modalState} text={<Box sx={{ whiteSpace: 'pre-wrap' }}>
      <Typography variant="subtitle2">Talk to me Goose</Typography>
      {theGooseStore.messages.map((message, index) => <Box key={index} mb={1}>
         {message.type === 'goose' ?
            <Typography variant="subtitle2" display="block">{message.message}</Typography> :
            <FlexAlignRight>
               <Typography variant="subtitle2" display="block" sx={{ float: 'right' }}>{message.message}</Typography>
            </FlexAlignRight>}
      </Box>)}
      {theGooseStore.formHandler.inputField.bindInput(ip =>
         <TextField placeholder="Type here..." size='small' fullWidth {...ip} onKeyDown={theGooseStore.onKeyDown} autoFocus />
      )}
   </Box>} />
})
